"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColumnClassNames = void 0;

var getColumnClassNames = function getColumnClassNames(size) {
  return typeof size === 'string' ? "col-".concat(size) : size.map(function (item) {
    return "col-".concat(item);
  }).reduce(function (acc, val) {
    return acc.concat(val);
  }, []).filter(function (item) {
    return item;
  }).join(' ');
};

exports.getColumnClassNames = getColumnClassNames;